export enum ListingStatus {
  DELETED = 'DELETED',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
  FROZEN = 'FROZEN',
  HIDDEN = 'HIDDEN',
  CHECKOUT = 'CHECKOUT',
  INVOICE = 'INVOICE',
  PULLED = 'PULLED',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SPAM = 'SPAM',
}

export const STATUSES = Object.defineProperties(
  {},
  Object.fromEntries(
    Object.entries({
      DELETED: getText('Deleted'),
      PUBLISHED: getText('Published'),
      DRAFT: getText('Draft'),
      ARCHIVED: getText('Expired'),
      FROZEN: getText('Frozen'),
      HIDDEN: getText('Hidden'),
      CHECKOUT: getText('In Cart'),
      INVOICE: getText('Invoiced'),
      PULLED: getText('Pulled from site'),
      APPROVED: getText('Approved'),
      PENDING: getText('Pending'),
      REJECTED: getText('Rejected'),
      SPAM: getText('Spam'),
    }).map(([key, value]) => [
      key,
      {
        enumerable: true,
        get() {
          return value;
        },
      },
    ]),
  ),
) as Record<ListingStatus, string>;
